import $ from 'jquery';
import _ from 'lodash';
import React from 'react';
import Immutable from 'immutable';
import ReactDOM from 'react-dom';

//
import GalleryActionCreators from './actions/GalleryActionCreators.js';
import ConversationStore from './stores/ConversationStore';
import MessageStore from './stores/MessageStore';
import GalleryStore from './stores/GalleryStore';
import MessagesApp from './components/MessagesApp.react';
import PrivateMessagesApp from './components/PrivateMessagesApp.react';
import GalleryApp from './components/GalleryApp.react';
import MessagesWebAPIUtils from './utils/MessagesWebAPIUtils.js';
import updateHandling from './utils/updateHandling.js';
import DiscussionsButtonBlock from './components/misc/DiscussionsButtonBlock.react';
import ActivityItemActionBlock from './components/misc/ActivityItemActionBlock.react';
import QuestionBlock from './components/questions/QuestionBlock.react';
import QuestionsActionCreators from './actions/QuestionsActionCreators.js';
import FlashMessageContainer from './components/flashMessages/FlashMessageContainer.react';
import RegisterFormContainer from './components/register/RegisterFormContainer.react';
import Quiz from './components/quiz/Quiz.react';
import { callIfRouteMatch } from './../app/util.js';
import popup from './../app/popup';
// New
import MemberStore from './../../react/stores/MemberStore';
import MembersGridContainer from './../../react/containers/member/MembersGridContainer.jsx';
import MatchesMembersContainer from './../../react/containers/matches/MatchesMembersContainer';
import SearchApp from './../../react/SearchApp';
import SearchSideContainer from './../../react/containers/search/SearchSideContainer';
import MatchesSearchApp from './../../react/MatchesSearchApp';
import NewMatchContainer from './../../react/containers/matches/NewMatchContainer';
import { PermissionsInfoContainer } from './../../react/components/permissionsInfo';
import SearchSlider from './../../react/components/search';
import PaymentsApp from './../../react/PaymentsApp';
import VerificationApp from './../../react/VerificationApp';
import VipApp from './../../react/VipApp';
import ImagesBlock from './../../react/components/image/ImagesBlock.jsx';
import MemberImageGallery from './../../react/components/member/MemberImageGallery';
import SuggestionsExtendedApp from './../../react/SuggestionsExtendedApp';
import DailyPollBlock from './../../react/components/polls/DailyPollBlock';
import DailyPollActionCreators from './../../react/actions/DailyPollActionCreators';
import OpenImage from './../../react/components/OpenImage';
import { PaymentSuccess } from './../../react/components/payments';
import DeleteMeContainer from './../../react/containers/settings/DeleteMeContainer';
import ProfileVotesContainer from './../../react/containers/matches/ProfileVotesContainer';
import gtm from './../../helpers/gtm';

// neierobežots eventu skaits
require('events').EventEmitter.prototype._maxListeners = 0;

window.React = React; // export for http://fb.me/react-devtools

// pjax container vērtības, pie kurām notiek lielās ielādes
// piem, ja atjauno vex modeli, tad tam ir cits container un nevajag tālāk izpildīt pjax event
const valid_containers = ['#content', '#main-panel'];

function valueToBool(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    if ((value == '1') || (value.toLowerCase() == 'true')) {
      return true;
    } else {
      return false;
    }
  }

  return parseInt(value) > 0;
}

module.exports = {
  init() {
    // popup.featureMessage('see_read_messages');
    // popup.featureMessage('search_name');
    // popup.featureMessage('videochat');
    // popup.featureMessage('pdf');
    // popup.featureMessage('noads');

    const self = this;
    //
    self.initMessages();
    self.initEmoticons();
    self.initQuiz();
    self.initSearchSlider();
    self.initNewGallery();
    self.initFlashMessages();
    self.initStatisticsActivityActions();
    self.initMembersGridContainer();
    self.initImagesBlockContainer();
    self.initGallery();
    self.initPayments();
    self.initPaymentSuccess();
    self.initQuestionBlock();
    self.initDailyPollBlock();
    self.initVerification();
    self.initDeleteMe();
    self.initVip();
    self.initProfileVotes();
    self.initMatchesMembers();
    //
    callIfRouteMatch('.*/search', () => {
      self.initPermissionsInfo();
      self.initSearch();
    });
    callIfRouteMatch('.*/matches_search', () => {
      self.initMatchesSearch();
    });
    callIfRouteMatch('.*/(matches|matches/my_likes|matches/likes_me)', () => {
      self.initMatchesFilter();
    });
    callIfRouteMatch('.*/(register_step2|external_register)', () => {
      self.initRegisterForm();
    });
    callIfRouteMatch('.*/suggestions/extended_form', () => {
      self.initSuggestionsExtendedApp();
    });
    //
    $(document).on('pjax:end', () => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      //
      self.initMessages();
      self.initEmoticons();
      self.initQuiz();
      self.initSearchSlider();
      self.initGallery();
      self.initFlashMessages();
      self.initStatisticsActivityActions();
      self.initMembersGridContainer();
      self.initImagesBlockContainer();
      self.initNewGallery();
      self.initPayments();
      self.initPaymentSuccess();
      self.initQuestionBlock();
      self.initDailyPollBlock();
      self.initVerification();
      self.initDeleteMe();
      self.initVip();
      self.initProfileVotes();
      self.initMatchesMembers();
      //
      callIfRouteMatch('.*/search', () => {
        self.initPermissionsInfo();
        self.initSearch();
      });
      callIfRouteMatch('.*/matches_search', () => {
        self.initMatchesSearch();
      });
      callIfRouteMatch('.*/(matches|matches/my_likes|matches/likes_me)', () => {
        self.initMatchesFilter();
      });
      callIfRouteMatch('.*/(register_step2|external_register)', () => {
        self.initRegisterForm();
      });
    });
  },
  initMessages() {
    const messages = document.getElementById('messages');
    if (typeof messages_init_data !== 'undefined' && messages !== null) {
      MessageStore.clearData();
      ConversationStore.setEmptyCurrentId();
      ConversationStore.setCanSelectConversation(false); // lai nav izvēlēta pirmā sarakste
      MessagesWebAPIUtils.initConversations(messages_init_data.conversations, messages_init_data.unread_conversations);
      MessagesWebAPIUtils.initMessages(messages_init_data.messages);
      MessagesWebAPIUtils.initMembers(messages_init_data.members, messages_init_data.character_limit, messages_init_data.limited_messages, messages_init_data.over_conversation_limit, messages_init_data.submit_on_enter, messages_init_data.has_paid);

      updateHandling.init();

      const root = ReactDOM.render(
        <MessagesApp />,
        messages,
      );

      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(messages);
      });
    }

    // private
    const privateMessages = document.getElementById('private-messages');
    if (typeof messages_init_data !== 'undefined' && privateMessages !== null) {
      GalleryStore.clearLocalImages();
      MessageStore.clearData();
      ConversationStore.setCanSelectConversation(true);
      ConversationStore.setCurrentId(messages_init_data.member_id);
      MessagesWebAPIUtils.initMessages(messages_init_data.messages, true, messages_init_data.member_id);
      MessagesWebAPIUtils.initMembers(messages_init_data.members, messages_init_data.character_limit, messages_init_data.limited_messages, messages_init_data.over_conversation_limit, messages_init_data.submit_on_enter, messages_init_data.has_paid);
      let hideTextArea;

      updateHandling.messages();

      ReactDOM.render(
        <PrivateMessagesApp activeMask={false} />,
        privateMessages,
      );

      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(privateMessages);
      });
    }
  },

  initEmoticons() {
    // iespējami vairāki konteineri: piemēram adminiem - 'rediģēt' un 'atbildēt' konteineri
    const emoticonsContainers = document.getElementsByClassName('emoticonsContainer');
    Array.prototype.map.call(emoticonsContainers, (container) => {
      if (container !== null) {
        ReactDOM.render(
          <DiscussionsButtonBlock />,
          container,
        );
      }
      $(document).on('pjax:end', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(container);
      });
    });
  },

  initMembersGridContainer() {
    const membersBlockContainers = document.getElementsByClassName('membersBlockContainer');
    Array.prototype.map.call(membersBlockContainers, (container) => {
      if (container !== null) {
        let members_id = [];
        let extended = false;
        let pagination = false;
        let slider = false;
        let sliderAutoplay = false;
        let slide_total = 8;
        let slide_total_responsive = null;
        let itemsCountPerPage = 20;
        let totalItemsCount;
        let header_title = '';
        let header_show_all = '';
        let type = 'regular';
        let menuType = 'user';
        let subtype = '';
        let section = 'default';
        let custom_images;
        let show_distance = false;
        let page = 1;
        let pagination_url = `${window.location.pathname}.json${window.location.search}`;
        let attributes = container.attributes,
          i = attributes.length;

        for (; i--;) {
          if (attributes[i].name == 'data-members-id') {
            members_id.push(attributes[i].value);
          }

          if (attributes[i].name == 'data-extended') {
            extended = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-pagination') {
            pagination = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-items-count-per-page') {
            itemsCountPerPage = parseInt(attributes[i].value);
          }

          if (attributes[i].name == 'data-slider') {
            slider = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-slider-autoplay') {
            sliderAutoplay = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-slide-total') {
            slide_total = parseInt(attributes[i].value);
          }

          if (attributes[i].name == 'data-slide-total-responsive' && attributes[i].value) {
            slide_total_responsive = parseInt(attributes[i].value);
          }

          if (attributes[i].name == 'data-total-items-count') {
            totalItemsCount = parseInt(attributes[i].value);
          }

          if (attributes[i].name == 'data-header-title') {
            header_title = attributes[i].value;
          }

          if (attributes[i].name == 'data-header-show-all') {
            // header_show_all = attributes[i].value.toLowerCase() == 'true' ? true : false;
            header_show_all = attributes[i].value;
          }

          if (attributes[i].name == 'data-type') {
            type = attributes[i].value;
          }

          if (attributes[i].name === 'data-menu_type') {
            menuType = attributes[i].value;
          }

          if (attributes[i].name == 'data-subtype') {
            subtype = attributes[i].value;
          }

          if (attributes[i].name == 'data-section') {
            section = attributes[i].value;
          }

          if (attributes[i].name == 'data-custom-images') {
            custom_images = attributes[i].value;
          }

          if (attributes[i].name == 'data-show-distance') {
            show_distance = attributes[i].value.toLowerCase() == 'true' ? true : false;
          }

          if (attributes[i].name == 'data-pagination-url' && attributes[i].value.length > 1) {
            pagination_url = attributes[i].value;
          }

          if (attributes[i].name == 'data-page') {
            page = parseInt(attributes[i].value);
          }
        }

        ReactDOM.render(
          <MembersGridContainer
            membersId={members_id}
            extended={extended}
            pagination={pagination}
            itemsCountPerPage={itemsCountPerPage}
            slider={slider}
            sliderAutoplay={sliderAutoplay}
            slideTotal={slide_total}
            slideTotalResponsive={slide_total_responsive}
            totalItemsCount={totalItemsCount}
            headerTitle={header_title}
            headerShowAll={header_show_all}
            type={type}
            menuType={menuType}
            subtype={subtype}
            section={section}
            customImages={custom_images}
            showDistance={show_distance}
            paginationUrl={pagination_url}
            page={page}
          />,
          container,
        );
      }
      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(container);
      });
    });
  },

  // old images block
  initImagesBlockContainer() {
    const imagesBlockContainer = document.getElementsByClassName('imagesBlockContainer');
    Array.prototype.map.call(imagesBlockContainer, (container) => {
      if (container !== null) {
        let memberId = '';
        let hasMenu= false;
        let menuType= '';
        let imagesLimit = 0;
        let myId = '';
        let myImage = '';
        let myStatus = '';
        let needAbo = false;
        let verificationRestrictions = false;

        let attributes = container.attributes,
          i = attributes.length;

        for (; i--;) {
          if (attributes[i].name == 'data-member-id') {
            memberId = attributes[i].value;
          }

          if (attributes[i].name == 'data-has-menu') {
            hasMenu = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-menu-type') {
            menuType = attributes[i].value;
          }

          if (attributes[i].name == 'data-images-limit') {
            imagesLimit = parseInt(attributes[i].value);
          }

          if (attributes[i].name == 'data-my-id') {
            myId = attributes[i].value;
          }

          if (attributes[i].name == 'data-my-image') {
            myImage = attributes[i].value;
          }

          if (attributes[i].name == 'data-my-status') {
            myStatus = attributes[i].value;
          }

          if (attributes[i].name == 'data-need-abo') {
            needAbo = valueToBool(attributes[i].value);
          }

          if (attributes[i].name == 'data-verification-restrictions') {
            verificationRestrictions = valueToBool(attributes[i].value);
          }
        }

        ReactDOM.render(
          <ImagesBlock
            memberId={memberId}
            hasMenu={hasMenu}
            menuType={menuType}
            imagesLimit={imagesLimit}
            myId={myId}
            myImage={myImage}
            myStatus={myStatus}
            needAbo={needAbo}
            verificationRestrictions={verificationRestrictions}
          />,
          container,
        );
      }

      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(container);
      });
    });
  },

  // new gallery
  initNewGallery() {
    console.log('initNewGallery');
    const galleryRoot = document.getElementById('galleryContainerInline')

    if (galleryRoot === null) {
      return;
    }

    const memberId = galleryRoot.getAttribute('data-member-id')

    GalleryStore.clearImages();
    GalleryStore.setLoad(true);
    GalleryActionCreators.galleryLoad(memberId);

    ReactDOM.render(
      <MemberImageGallery
        memberId={memberId}
      />,
      galleryRoot,
    );


    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.galleryRoot) == -1) {
        return;
      }
      console.log('unmountComponentAtNode', galleryRoot);
      ReactDOM.unmountComponentAtNode(galleryRoot);
    });
  },


  initQuiz() {
    const quizContainers = document.getElementsByClassName('quiz-container');
    Array.prototype.map.call(quizContainers, (container) => {
      if (container !== null) {
        const attributes = container.attributes;
        let i = attributes.length;
        let show_results = false;
        let result_id = null;
        let hide_results = false;
        let results_type = 'default';

        for (; i--;) {
          if (/^data-.*/.test(attributes[i].name)) {
            if (attributes[i].name == 'data-show-results') {
              show_results = attributes[i].value;
            }

            if (attributes[i].name == 'data-result-id') {
              result_id = attributes[i].value;
            }

            if (attributes[i].name == 'data-hide-results') {
              hide_results = attributes[i].value;
            }

            if (attributes[i].name == 'data-results-type') {
              results_type = attributes[i].value;
            }
          }
        }

        ReactDOM.render(
          <Quiz
            show_results={show_results}
            result_id={result_id}
            hide_results={hide_results}
            results_type={results_type}
          />,
          container,
        );
      }
      $(document).on('pjax:end', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(container);
      });
    });
  },
  initStatisticsActivityActions() {
    const activityItemActionContainers = document.getElementsByClassName('activityItem-actionsMore');
    Array.prototype.map.call(activityItemActionContainers, (container) => {
      if (container !== null) {
        let member_id = null;
        let member_blocked = 0;
        let member_ignored = 0;

        let attributes = container.attributes,
          i = attributes.length;

        for (; i--;) {
          if (/^data-.*/.test(attributes[i].name)) {
            if (attributes[i].name == 'data-member-id') {
              member_id = attributes[i].value;
            }

            if (attributes[i].name == 'data-member-blocked') {
              member_blocked = attributes[i].value;
            }

            if (attributes[i].name == 'data-member-ignored') {
              member_ignored = attributes[i].value;
            }
          }
        }

        ReactDOM.render(
          <ActivityItemActionBlock member_id={member_id} member_blocked={member_blocked} member_ignored={member_ignored} />,
          container,
        );
      }
      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(container);
      });
    });
  },
  initGallery() {
    // aizvērt galeriju
    const _this = this;
    const closeGallery = function (e) {
      if (e) {
        e.preventDefault();
      }
      const gallery = document.getElementById('gallery');
      if (!gallery) {
        return false;
      }

      $('#searchSlider').show();

      ReactDOM.unmountComponentAtNode(gallery);
    };

    //
    const openLocalGallery = function (gotoImage) {
      if (!GalleryStore.getLocalTotal()) {
        return;
      }

      GalleryStore.clearImages();
      GalleryStore.setLoad(true);

      ReactDOM.render(
        <GalleryApp
          onClose={closeGallery}
          showReportButton={false}
          showLikeButton={false}
          showComplimentButton={false}
        />,
        gallery,
      );

      const localImages = GalleryStore.getLocalImages();
      GalleryActionCreators.loadLocal(localImages, gotoImage);
    }

    //
    const openMemberGallery = function (memberId, gotoImage) {
      //
      const galleryMemberId = GalleryStore.getMemberId();
      if (galleryMemberId && galleryMemberId === memberId) {
        GalleryStore.setCurrentByFilename(gotoImage);
      } else {
        const memberGalleryImages = GalleryStore.getMemberImages(memberId);
        if (memberGalleryImages) {
          GalleryStore.setEmpty(false);
          GalleryStore.setImages(memberGalleryImages, gotoImage);
          GalleryStore.setMemberId(memberId);
        } else {
          GalleryStore.clearImages();
          GalleryStore.setLoad(true);
          GalleryActionCreators.galleryLoad(memberId, gotoImage);
        }
      }

      ReactDOM.render(<GalleryApp onClose={closeGallery} />, gallery);
    }

    // atvērt galeriju
    const openGallery = function (gotoImage, loadLocal, memberId) {

      $('#searchSlider').hide();

      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        closeGallery();
      });

      return loadLocal ? openLocalGallery(gotoImage) : openMemberGallery(memberId, gotoImage);
    };

    // ja url ir parametrs opengallery, tad atver galeriju
    const openByUrl = function () {
      const path_array = window.location.pathname.split('/');
      const position = path_array.indexOf('opengallery');
      let image_name = '';

      if (position == -1) {
        return false;
      }

      if (typeof path_array[position + 1] !== 'undefined') {
        image_name = path_array[position + 1];
      }
      openGallery(image_name);
    };

    openByUrl();

    //
    const openImage = function (src) {
      ReactDOM.render(
        <OpenImage
          src={src}
          onClose={closeGallery}
        />,
        gallery,
      );
    }

    $(document).on('pjax:end', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      openByUrl();
    });

    $(document).off('click', '.op-gallery-open');
    // atvērt galeriju un konkrēto bildi
    $(document).on('click', '.op-gallery-open', function (e) {
      e.preventDefault();

      // kuru bildi atvērt
      const gotoImage = $(this).data('file');
      const loadLocal = $(this).data('loadLocal');
      const memberId = $(this).data('memberId');
      openGallery(gotoImage, loadLocal, memberId);
    });

    $(document).off('click', '.op-image-open');
    // open single image
    $(document).on('click', '.op-image-open', function (e) {
      e.preventDefault();

      const src = $(this).data('src');
      openImage(src);
    });
  },
  initQuestionBlock() {
    if (!_.get(globals, 'currentMember.id', null)) {
      return;
    }

    const questionBlock = document.getElementById('question-block');
    if (questionBlock === null) {
      return;
    }

    QuestionsActionCreators.loadNextUnanswered();

    ReactDOM.render(
      <QuestionBlock />,
      questionBlock,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(questionBlock);
    });
  },
  initFlashMessages() {
    const flashContainer = document.getElementById('flash-react-container');
    if (flashContainer !== null) {
      ReactDOM.render(
        <FlashMessageContainer />,
        flashContainer,
      );

      $(document).on('pjax:beforeReplace', (event, contents, options) => {
        if (valid_containers.indexOf($.pjax.state.container) == -1) {
          return;
        }
        ReactDOM.unmountComponentAtNode(flashContainer);
      });
    }
  },

  initSearchSlider() {
    const searchSliderContainer = document.getElementById('searchSlider');
    if (searchSliderContainer === null) {
      return;
    }

    const memberIdRegex = /.*\/member\/([A-Z0-9]*)(\/.*)?/g;
    const memberIdMatches = memberIdRegex.exec(window.location.pathname);
    if (!memberIdMatches || !memberIdMatches[1]) {
      MemberStore.removeSearchedMemberIds();
      ReactDOM.unmountComponentAtNode(searchSliderContainer);
      return;
    }

    ReactDOM.render(
      <SearchSlider />,
      searchSliderContainer,
    );
  },

  initPayments() {
    const paymentsRoot = document.getElementById('payments-root');
    if (paymentsRoot === null) {
      return;
    }

    let verificationStatus = '';

    const { attributes } = paymentsRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-verification-status') {
        verificationStatus = attributes[i].value;
      }
    }

    ReactDOM.render(
      <PaymentsApp
        verificationStatus={verificationStatus}
      />,
      paymentsRoot,
    );
  },

  initPaymentSuccess() {
    const paymentSuccessRoot = document.getElementById('payment-success');
    if (paymentSuccessRoot === null) {
      return;
    }

    const purchaseEcommerce = _.get(globals, 'purchase_ecommerce', null);
    if (purchaseEcommerce) {
      gtm.track({ event: 'purchase', ecommerce: purchaseEcommerce });
    }


    let type = '';
    let active = '';
    let verificationStatus = '';
    let messagesCharacterLimit = null;

    const { attributes } = paymentSuccessRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-type') {
        type = attributes[i].value;
      }

      if (attributes[i].name === 'data-active') {
        active = attributes[i].value;
      }

      if (attributes[i].name === 'data-verification-status') {
        verificationStatus = attributes[i].value;
      }

      if (attributes[i].name === 'data-messages-character-limit') {
        messagesCharacterLimit = parseInt(attributes[i].value);
      }
    }

    ReactDOM.render(
      <PaymentSuccess
        type={type}
        active={active}
        verificationStatus={verificationStatus}
        messagesCharacterLimit={messagesCharacterLimit}
      />,
      paymentSuccessRoot,
    );
  },

  initPermissionsInfo() {
    const permissionsInfoContainer = document.getElementById('permissionsInfo');
    if (permissionsInfoContainer === null) {
      return;
    }

    ReactDOM.render(
      <PermissionsInfoContainer permissions={localStorage.permissions} />,
      permissionsInfoContainer,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(permissionsInfoContainer);
    });
  },

  initSearch() {
    const searchRoot = document.getElementById('search-root');
    if (searchRoot === null) {
      return;
    }

    let membersId = [];
    let extended = false;
    let pagination = false;
    let slider = false;
    let slideTotal = 8;
    let itemsCountPerPage = 20;
    let totalItemsCount = 0;
    let headerTitle = '';
    let headerShowAll = '';
    let type = 'regular';
    let menuType = 'user';
    let customImages = null;
    let page = 1;
    let paginationUrl = `${window.location.pathname}${window.location.search}`;
    let showName = true;

    const { attributes } = searchRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-members-id') {
        membersId = attributes[i].value;
      }

      if (attributes[i].name === 'data-extended') {
        extended = (attributes[i].value === 'true' || attributes[i].value === '1');
      }

      if (attributes[i].name === 'data-pagination') {
        pagination = (attributes[i].value === 'true' || attributes[i].value === '1');
      }

      if (attributes[i].name === 'data-items-count-per-page') {
        itemsCountPerPage = attributes[i].value;
      }

      if (attributes[i].name === 'data-slider') {
        slider = attributes[i].value;
      }

      if (attributes[i].name === 'data-slide-total') {
        slideTotal = attributes[i].value;
      }

      if (attributes[i].name === 'data-total-items-count') {
        totalItemsCount = attributes[i].value;
      }

      if (attributes[i].name === 'data-header-title') {
        headerTitle = attributes[i].value;
      }

      if (attributes[i].name === 'data-header-show-all') {
        headerShowAll = attributes[i].value;
      }

      if (attributes[i].name === 'data-type') {
        type = attributes[i].value;
      }

      if (attributes[i].name === 'data-menu_type') {
        menuType = attributes[i].value;
      }

      if (attributes[i].name === 'data-custom-images') {
        customImages = attributes[i].value;
      }

      if (attributes[i].name === 'data-pagination-url' && attributes[i].value.length > 1) {
        paginationUrl = attributes[i].value;
      }

      if (attributes[i].name === 'data-page') {
        page = parseInt(attributes[i].value, 10);
      }

      if (attributes[i].name === 'data-show-name') {
        showName = (attributes[i].value === 'true' || attributes[i].value === '1');
      }
    }

    ReactDOM.render(
      <SearchApp
        membersId={membersId}
        extended={extended}
        pagination={pagination}
        itemsCountPerPage={itemsCountPerPage}
        slider={slider}
        slideTotal={slideTotal}
        totalItemsCount={totalItemsCount}
        headerTitle={headerTitle}
        headerShowAll={headerShowAll}
        type={type}
        customImages={customImages}
        paginationUrl={paginationUrl}
        page={page}
        showName={showName}
        menuType={menuType}
      />,
      searchRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(searchRoot);
    });
  },

  handleFormSubmission(data) {
    console.log("handleFormSubmission", data);
    window.location.href = "/matches/matches_search?" + data;
  },

  initMatchesFilter() {
    const filterMatchesRoot = document.getElementById('matches-filter-root');
    if (filterMatchesRoot === null) {
      return;
    }

    ReactDOM.render(
      <SearchSideContainer
        submitForm={() => {}}
        submitSideForm={this.handleFormSubmission}
        type="side"
        subType="my_likes"
      />,
      filterMatchesRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(filterMatchesRoot);
    });
  },

  initMatchesSearch() {
    const searchMatchesRoot = document.getElementById('matches-search-root');
    if (searchMatchesRoot === null) {
      return;
    }

    let myId = '';
    let myImage = '';
    let myStatus = '';
    let needAbo = false;
    let verificationRestrictions = false;
    let noAboLimitReached = false;

    const { attributes } = searchMatchesRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name == 'data-my-id') {
        myId = attributes[i].value;
      }

      if (attributes[i].name == 'data-my-image') {
        myImage = attributes[i].value;
      }

      if (attributes[i].name == 'data-my-status') {
        myStatus = attributes[i].value;
      }

      if (attributes[i].name == 'data-need-abo') {
        needAbo = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-verification-restrictions') {
        verificationRestrictions = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-no-abo-limit-reached') {
        noAboLimitReached = valueToBool(attributes[i].value);
      }
    }

    ReactDOM.render(
      <MatchesSearchApp
        myId={myId}
        myImage={myImage}
        myStatus={myStatus}
        needAbo={needAbo}
        verificationRestrictions={verificationRestrictions}
        noAboLimitReached={noAboLimitReached}
      />,
      searchMatchesRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(searchMatchesRoot);
    });
  },

  initRegisterForm() {
    const registerFormContainer = document.getElementById('register-form');
    if (typeof registerFormContainer === 'undefined'
        || registerFormContainer === null
        || typeof field_token === 'undefined'
        || field_token == null
        || !_.get(globals, 'recaptchaSiteKey', null)
        || !_.get(globals, 'defaultCountryId', null)
    ) {
      return;
    }

    let excluded = [];
    let external = false;
    let registerMethod = 'email';

    const external_register = window.location.pathname.indexOf('external_register');
    if (external_register != -1) {
      external = true;
      registerMethod = window.location.pathname.slice(external_register).split('/')[1];
    }

    gtm.track({ event: 'begin_register', registerMethod });

    var formTranslations = _.get(translations, 'registration', false);
    if (!formTranslations && registration_translations !== 'undefined') {
        formTranslations = registration_translations;
    }

    ReactDOM.render(
      <RegisterFormContainer
        external={external}
        excluded={excluded}
        recaptcha_site_key={_.get(globals, 'recaptchaSiteKey', '')}
        phone_activation={_.get(globals, 'smsActivation')}
        translations={formTranslations}
        field_token={field_token}
        default_country_id={_.get(globals, 'defaultCountryId', null)}
      />,
      registerFormContainer,
    );
  },

  initSuggestionsExtendedApp() {
    const suggestionsExtended = document.getElementById('suggestions-extended');
    if (suggestionsExtended === null) {
      return;
    }

    ReactDOM.render(
      <SuggestionsExtendedApp />,
      suggestionsExtended,
    );
  },

  initDailyPollBlock() {
    if (!_.get(globals, 'currentMember.id', null)) {
      return;
    }

    const dailyPollBlock = document.getElementById('dailyPoll-block');
    if (dailyPollBlock === null) {
      return;
    }

    DailyPollActionCreators.loadDailyPoll(dailyPollBlock.dataset.id);

    ReactDOM.render(
      <DailyPollBlock preview={dailyPollBlock.dataset.preview === '1'} />,
      dailyPollBlock,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(dailyPollBlock);
    });
  },
  initVerification() {
    const verificationRoot = document.getElementById('verification-root');
    if (verificationRoot === null) {
      return;
    }

    let verificationStatus = '';
    let verificationImage = '';
    let myStatus = '';
    let myImage = '';
    let myGender = '';
    let adminComment = '';
    let isSimulated = false;
    let showContactInfo = false;
    let verificationRestrictions = false;
    let messagesCharacterLimit = null;

    const { attributes } = verificationRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-verification-status') {
        verificationStatus = attributes[i].value;
      }

      if (attributes[i].name === 'data-verification-image') {
        verificationImage = attributes[i].value;
      }

      if (attributes[i].name === 'data-my-status') {
        myStatus = attributes[i].value;
      }

      if (attributes[i].name === 'data-my-image') {
        myImage = attributes[i].value;
      }

      if (attributes[i].name === 'data-my-gender') {
        myGender = attributes[i].value.toLowerCase();
      }

      if (attributes[i].name === 'data-admin-comment') {
        adminComment = attributes[i].value;
      }

      if (attributes[i].name === 'data-is-simulated') {
        isSimulated = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-show-contact-info') {
        showContactInfo = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-verification-restrictions') {
        verificationRestrictions = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-messages-character-limit') {
        messagesCharacterLimit = parseInt(attributes[i].value);
      }
    }

    ReactDOM.render(
      <VerificationApp
        verificationStatus={verificationStatus}
        verificationImage={verificationImage}
        myStatus={myStatus}
        myImage={myImage}
        myGender={myGender}
        adminComment={adminComment}
        isSimulated={isSimulated}
        showContactInfo={showContactInfo}
        verificationRestrictions={verificationRestrictions}
        messagesCharacterLimit={messagesCharacterLimit}
      />,
      verificationRoot,
    );
  },
  initDeleteMe() {
    const deleteMeRoot = document.getElementById('delete-me');
    if (deleteMeRoot === null) {
      return;
    }

    gtm.track({ event: 'begin_delete_me' });

    ReactDOM.render(
      <DeleteMeContainer />,
      deleteMeRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(deleteMeRoot);
    });
  },
  initVip() {
    const vipRoot = document.getElementById('vip-root');
    if (vipRoot === null) {
      return;
    }

    let vipSubscribed = false;
    let vipOn = false;
    let vipIcon = false;
    let vipName = '';

    const { attributes } = vipRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-vip-subscribed') {
        vipSubscribed = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-vip-on') {
        vipOn = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-vip-icon') {
        vipIcon = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-vip-name') {
        vipName = attributes[i].value;
      }
    }

    ReactDOM.render(
      <VipApp
        vipSubscribed={vipSubscribed}
        vipOn={vipOn}
        vipName={vipName}
        vipIcon={vipIcon}
      />,
      vipRoot,
    );
  },

  initProfileVotes() {
    const profileVotesRoot = document.getElementById('profile-votes');
    if (profileVotesRoot === null) {
      return;
    }

    let memberId = '';
    let isLiked = false;
    let isDisliked = false;
    let noAboLimitReached = false;
    let hasMatch = false;

    const { attributes } = profileVotesRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-member-id') {
        memberId = attributes[i].value;
      }

      if (attributes[i].name === 'data-is-liked') {
        isLiked = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-is-disliked') {
        isDisliked = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-no-abo-limit-reached') {
        noAboLimitReached = valueToBool(attributes[i].value);
      }

      if (attributes[i].name === 'data-has-match') {
        hasMatch = valueToBool(attributes[i].value);
      }
    }

    ReactDOM.render(
      <div>
        <ProfileVotesContainer
          memberId={memberId}
          isLiked={isLiked}
          isDisliked={isDisliked}
          noAboLimitReached={noAboLimitReached}
          hasMatch={hasMatch}
        />
        <NewMatchContainer />
      </div>,
      profileVotesRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(profileVotesRoot);
    });
  },

  initMatchesMembers() {
    const matchesMembersRoot = document.getElementById('matches-members');
    if (matchesMembersRoot === null) {
      return;
    }

    let api = '';
    let page = 1;
    let itemsPerPage = 20;
    let includeSkip = false;
    let noAboLimitReached = false;

    const { attributes } = matchesMembersRoot;
    let i = attributes.length - 1;

    for (i; i >= 0; i -= 1) {
      if (attributes[i].name === 'data-api') {
        api = attributes[i].value;
      }

      if (attributes[i].name === 'data-page') {
        page = parseInt(attributes[i].value, 10);
      }

      if (attributes[i].name === 'data-items-per-page') {
        itemsPerPage = parseInt(attributes[i].value, 10);
      }

      if (attributes[i].name === 'data-include-skip') {
        includeSkip = valueToBool(attributes[i].value);
      }

      if (attributes[i].name == 'data-no-abo-limit-reached') {
        noAboLimitReached = valueToBool(attributes[i].value);
      }
    }

    ReactDOM.render(
      <div>
        <MatchesMembersContainer
          api={api}
          page={page}
          itemsPerPage={itemsPerPage}
          includeSkip={includeSkip}
          noAboLimitReached={noAboLimitReached}
        />
        <NewMatchContainer />
      </div>,
      matchesMembersRoot,
    );

    $(document).on('pjax:beforeReplace', (event, contents, options) => {
      if (valid_containers.indexOf($.pjax.state.container) == -1) {
        return;
      }
      ReactDOM.unmountComponentAtNode(matchesMembersRoot);
    });
  },
};
